import { render, staticRenderFns } from "./reviewSubmissions.vue?vue&type=template&id=39126804&scoped=true&lang=html&"
import script from "./reviewSubmissions.vue?vue&type=script&lang=ts&"
export * from "./reviewSubmissions.vue?vue&type=script&lang=ts&"
import style0 from "./reviewSubmissions.vue?vue&type=style&index=0&id=39126804&scoped=true&lang=scss&"
import style1 from "./reviewSubmissions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39126804",
  null
  
)

export default component.exports